import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/core/services/config.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NoraAPIService {
  noraAPIKey = this.configService.config.noraV2.noraApiKey;
  private checkUserApiUrl = `${this.configService.config.noraV2.noraApiBaseUrl}/user/check-user`;
  private uploadAudioApiUrl = `${this.configService.config.noraV2.noraApiBaseUrl}/nora/clinical_notes`;
  private getConsultationStatusApiUrl = `${this.configService.config.noraV2.noraApiBaseUrl}/nora/clinical_notes`;
  // Same paths the legacy account-settings tab used before commit e633c0589
  // pointed the recorder at the new Nora backend. Re-introduced for HBC Go's
  // in-panel format picker; if /v1 doesn't serve them the callers degrade
  // gracefully (empty list → selector stays hidden).
  private userTemplateApiUrl = `${this.configService.config.noraV2.noraApiBaseUrl}/user/settings/user-template`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  getPresignedUrl(
    practiceId: string,
    encounterId: string,
    fileName: string,
    contentType: string,
    micUsed: string,
    recordingDuration: number,
    notesType: string,
    lang: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'x-api-key': this.noraAPIKey,
      DoctorID: practiceId,
      ConsultationID: encounterId,
      'Content-Type': contentType,
      'Microphone-Selected': micUsed,
      'Audio-Duration': recordingDuration.toString(),
      'Con-Mode': notesType,
      lang,
    });

    return this.http.put<any>(this.uploadAudioApiUrl, null, { headers });
  }

  //Consultation Status Endpoints

  async getConsultationStatus(doctorId: string, encounterId: string) {
    try {
      const response = await fetch(this.getConsultationStatusApiUrl, {
        method: 'GET',
        headers: {
          'x-api-key': this.noraAPIKey,
          DoctorID: doctorId,
          ConsultationID: encounterId,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to get consultation status. Status: ${response.status}`);
      }

      const data = response.json();
      return data;
    } catch (error) {
      console.error('Error getting consultation status:', error);
      throw error;
    }
  }

  //Regenerate Endpoints

  async deleteNotes(doctorId: string, encounterId: string) {
    try {
      const response = await fetch(this.uploadAudioApiUrl, {
        method: 'DELETE',
        headers: {
          'x-api-key': this.noraAPIKey,
          DoctorID: doctorId,
          ConsultationID: encounterId,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to get consultation status. Status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting notes:', error);
      throw error;
    }
  }

  async saveNoteFormat(doctorId: string, templateId: string) {
    try {
      const response = await fetch(this.userTemplateApiUrl, {
        method: 'POST',
        headers: {
          'x-api-key': this.noraAPIKey,
          DoctorID: doctorId,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ template_id: templateId }),
      });
      if (!response.ok) {
        throw new Error(`Failed to save note format. Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error saving note format:', error);
      throw error;
    }
  }

  async checkUser(doctorId: string) {
    try {
      const response = await fetch(this.checkUserApiUrl, {
        method: 'GET',
        headers: {
          'x-api-key': this.noraAPIKey,
          DoctorID: doctorId,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to check user. Status: ${response.status}`);
      }

      const data = await response.json();
      // console.log(data);
      return data;
    } catch (error) {
      throw error;
    }
  }
}
